import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { getAuthenticationOptions } from '../selectors/getAuthenticationOptions';
import { getSecurityOptions } from '../selectors/getSecurityOptions';
import strings from 'owa-strings/owa-options-strings';
var styles = require('./BasicAuthenticationOptions.scss');
var BasicAuthenticationOptions = /** @class */ (function (_super) {
    tslib_1.__extends(BasicAuthenticationOptions, _super);
    function BasicAuthenticationOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onIncomingAuthChanged = function (option, index) {
            _this.props.onUpdateIncomingAuth(option.key);
        };
        _this.onIncomingSecurityChanged = function (option, index) {
            _this.props.onUpdateIncomingSecurity(option.key);
        };
        return _this;
    }
    BasicAuthenticationOptions.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Dropdown, { className: styles.dropdown, label: strings.options_connected_advanced_authenticationDropdown, onChanged: this.onIncomingAuthChanged, options: getAuthenticationOptions(this.props.connectionType), selectedKey: this.props.incomingAuth }),
            React.createElement(Dropdown, { className: styles.dropdown, label: strings.options_connected_advanced_encryptionDropdown, onChanged: this.onIncomingSecurityChanged, options: getSecurityOptions(), selectedKey: this.props.incomingSecurity })));
    };
    BasicAuthenticationOptions = tslib_1.__decorate([
        observer
    ], BasicAuthenticationOptions);
    return BasicAuthenticationOptions;
}(React.Component));
export default BasicAuthenticationOptions;
//# sourceMappingURL=BasicAuthenticationOptions.js.map